import * as React from 'react';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { Button, PRIORITY } from 'wix-ui-tpa/Button';
import { withTPAConfig } from '@wix/social-groups-common';
import { TPAComponentsConfig } from 'wix-ui-tpa/TPAComponentsConfig';

import styles from './EmptyState.st.css';

export interface EmptyStateProps {
  title?: string;
  content: string;
  button?:
    | React.ReactElement
    | {
        label: string;
        onClick(): void;
      };
}

const EmptyStateComponent: React.FC<EmptyStateProps &
  TPAComponentsConfig> = props => {
  const { title, content, button, mobile } = props;

  const renderButton = () => {
    return React.isValidElement(button) ? (
      button
    ) : (
      <Button priority={PRIORITY.primary} onClick={button.onClick}>
        {button.label}
      </Button>
    );
  };

  return (
    <div {...styles('root', { mobile }, props)}>
      {title && <Text typography={TYPOGRAPHY.smallTitle}>{title}</Text>}
      <Text
        typography={TYPOGRAPHY.listText}
        className={styles.content}
        tagName="p"
      >
        {content}
      </Text>
      {button ? renderButton() : null}
    </div>
  );
};

export const EmptyState = withTPAConfig(
  EmptyStateComponent,
) as React.ComponentType<EmptyStateProps>;
